import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
  name: 'almacenes',
})
export class AlmacenesPipe implements PipeTransform {

  transform(items: any[], filter: any[]) {

    if(filter['id_familia'] > 0){
      items = items.filter(function(item) {
        return item.id_familia == filter['id_familia'];
      });
    }


    return items;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/almacenes/almacenes.ts